import React, { useContext, useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { SRLWrapper } from "simple-react-lightbox";
import { SessionContext } from '../../common/SessionContext';

function FundingDetailsTab(props) {

    return (
        <div
            className="tab-pane fade show active package-info-tab"
            id="pill-body1"
            role="tabpanel"
            aria-labelledby="pills-package1"
        >
            <div className="workshop_bodytext">

                <p>We do everything we can to make our courses as cheap as possible, but we know that sometimes it can be hard to get the cash together fast enough to grab an amazing opportunity. Read on for info on payment plans, funding opportunities and other ways to make your CAMP session happen.</p>

                <h4 className="funding_title">Open Grants</h4>
                <p>Our Open Grants program offers grants of up to 50% of the cost of your CAMP session. The application form is quick and easy, and applications are usually assessed within a couple of hours - apply online at <a href="https://www.campfr.com/apply">campfr.com/funding</a>. If you're awarded a grant, you can also split the remaining payment (see the next bit of this page) making things even more manageable. For example - if you get a 50% grant, and then split the remaining 50%, you pay just €173 per month over 4 months.</p>

                <p>Open Grants are only available for our onsite program, not our online workshops.</p>

                <p>Please note: the application should be completed before you reserve a place.</p>


                <h4 className="funding_title">Payment Plan</h4>
                <p>You can pay your course fee in 4 monthly installments. Payments are automatically taken at one month intervals. So, if you pay the deposit on the 10th of March, the next payment will be taken on the 10th of April, and so on until the full course fee is paid. There are no credit checks or anything like that, everyone qualifies for access.</p>

                <p>You can split your payment even if you receive an Open Grant (see above). There's more information about payment splits in our terms.</p>


                <h4 className="funding_title">Educational Match Program</h4>
                <p>Please note: The Educational Match program is being phased out in favour of the Open Grants program. From May 2024, no new grants will be given - please refer to the Open Grants section above instead.</p>


                <h4 className="funding_title">Funding</h4>
                <p>We believe strongly in the idea that it is the responsibility of governments to support the cultural potential of their citizens. We will be very happy to help with funding applications, and can provide letters of invitation and any other documentation requested by your chosen funding body.</p>

                <p>For European travel and project grants, check out <a href="https://www.transartists.org/en/funding-europe" target="_blank">this page</a> on the TransArtists website. There's also a guide for artists <a href="https://www.transartists.org/article/funding-worldwide" target="_blank">outside Europe</a>.</p>

                <p>If you're in the UK and looking for funding for a music-based course, make sure you check out <a href="https://www.helpmusicians.org.uk/" target="_blank">Help Musicians UK</a>. They're great people, and their funding and advice is both accessible and responsive. Their <a href="https://www.helpmusicians.org.uk/creative-programme/current-opportunities/transmission-fund" target="_blank">Transmission Fund</a> is perfect for CAMP workshops, and they have a really useful Funding Wizard, which you can find <a href="https://www.helpmusicians.org.uk/creative-programme/funding-wizard" target="_blank">here</a>.</p>

                <p>Also for UK artists seeking funding, <a href="https://jerwoodarts.org/resource/signpost-funding-and-resources-for-uk-based-artists-and-artist-led-organisations/" target="_blank">this list of funding opportunities</a> by Jerwood Arts is excellent.</p>

            </div>

        </div>
    );
}

export default FundingDetailsTab;
